<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">My Requests</a>
  </div>
  <div class="container">
    <!-- Filter Bar -->
    <div class="filter-bar" [hidden]="loading">
      <form class="pure-form">
        <app-multi-select-input
          [label]="'Status'"
          [selectOptionList]="distinctStatuses"
          [selectedOptions]="selectedStatuses"
          (selectOptionUpdated)="onStatusFilterChange($event)"
        ></app-multi-select-input>

        <select [(ngModel)]="countryCodeFilter" (change)="applyFilters()" name="countryCodeFilter">
          <option value="">All Country Codes</option>
          <option *ngFor="let countryCode of distinctCountryCodes" [value]="countryCode">{{ countryCode }}</option>
        </select>

        <select [(ngModel)]="transitTimeTypeFilter" (change)="applyFilters()" name="transitTimeTypeFilter">
          <option value="">All Transit Time Types</option>
          <option *ngFor="let transitTimeType of distinctTransitTimeTypes" [value]="transitTimeType">{{ transitTimeType }}</option>
        </select>

        <button class="pure-button" type="button" (click)="clearFilters()">Clear Filters</button>
        <button class="pure-button pure-button-primary" type="button" (click)="fetchRequests()">Refresh</button>
      </form>
    </div>

    <!-- Results Table -->
    <div *ngIf="filteredRequests.length > 0 && !loading">
      <table class="pure-table pure-table-horizontal">
        <thead>
          <tr>
            <th>Business Use Case</th>
            <th>From Country Code</th>
            <th>Level Of Data</th>
            <th>Transit Time Type</th>
            <th>Request Status</th>
            <th>Request Type</th>
            <th>Created Time (UTC)</th>
            <th>Last Updated Time (UTC)</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredRequests">
            <td>{{ row.businessUseCase || "N/A" }}</td>
            <td>{{ row.fromCountryCode || "N/A" }}</td>
            <td>{{ row.componentKeyValue || "N/A" }}</td>
            <td>{{ row.transitTimeType || "N/A" }}</td>
            <td>{{ row.requestStatus || "N/A" }}</td>
            <td>{{ row.requestType || "N/A" }}</td>
            <td>{{ row.timestamp ? commonUtils.convertToDate(row.timestamp) : "N/A" }}</td>
            <td>{{ row.lastUpdatedTime ? commonUtils.convertToDate(row.lastUpdatedTime) : "N/A" }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty State -->
    <div *ngIf="allRequests.length === 0 && !loading">
      <h2>You have no in-progress requests.</h2>
    </div>

    <div *ngIf="filteredRequests.length === 0 && allRequests.length > 0 && !loading">
      <h2>No requests match the selected filters.</h2>
    </div>

    <app-loader [loading]="loading" [size]="'small'"></app-loader>
  </div>
</div>
